<template>
  <div style="z-index: 999">
    <v-app-bar color="transparent" class="elevation-0" app width="100px">
      <button
        :style="main"
        v-if="
          $route.path.split('/')[1] != 'pois' &&
          $route.path.split('/')[1] != 'route'
        "
        @click.stop="openDrawer"
        style="position: absolute; left: 25px"
      >
        <transition name="fade">
          <img
            v-if="menuIconColor == 'blue' && $route.path != '/'"
            src="@/assets/icons/Burger Menu_grey.svg"
            style="height: 23px; width: auto"
          />
        </transition>
        <transition name="fade">
          <img
            v-if="menuIconColor == 'white' || $route.path == '/'"
            src="@/assets/icons/Burger Menu_white.svg"
            style="height: 23px; width: auto"
          />
        </transition>
      </button>
      <button
        :style="main"
        v-if="
          $route.path.split('/')[1] == 'pois' ||
          $route.path.split('/')[1] == 'route'
        "
        @click="$router.go(-1)"
        style="position: absolute; left: 25px; z-index: 99"
      >
        <transition name="fade">
          <img
            v-if="menuIconColor == 'blue'"
            src="@/assets/icons/back_button.svg"
            style="height: 23px; width: auto"
          />
        </transition>
        <transition name="fade">
          <img
            v-if="menuIconColor == 'white'"
            src="@/assets/icons/back_button_white.svg"
            style="height: 23px; width: auto"
          />
        </transition>
      </button>
    </v-app-bar>
    <!-- appbar -->

    <!-- navigation drawer -->
    <v-navigation-drawer
      v-model="drawer"
      temporary
      app
      color="primary"
      width="300px"
      overlay-opacity="0"
      style="z-index: 100"
    >
      <!-- Top -->
      <template v-slot:prepend>
        <!-- Close Button -->
        <div class="d-flex mt-2 px-4">
          <button :style="nav" @click="closeDrawer" class="ml-auto mr-4">
            <img
              src="@/assets/icons/Close Button.svg"
              style="height: 27px; width: auto"
            />
          </button>
        </div>
      </template>

      <!-- Items -->
      <div
        class="d-flex flex-column justify-start align-start px-4 mt-5"
        :style="nav"
      >
        <div class="d-flex flex-column">
          <div v-for="(item, i) in menu" :key="i">
            <v-btn
              class="active white--text"
              :to="item.path"
              text
              :ripple="false"
              @click.native="closeDrawer()"
              style="height: auto; margin-bottom: 8px; padding: 8px"
            >
              <div
                class="white--text font-weight-light"
                style="font-size: 14px"
              >
                {{ item.label }}
              </div>
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Languages -->

      <div class="d-flex flex-column justify-start align-start px-4 mt-5">
        <div class="d-flex flex-column">
          <div v-for="(lang, i) in languages" :key="i">
            <v-btn
              class="active white--text"
              text
              :ripple="false"
              @click.native="onLanguageSelect(lang)"
              style="height: auto; margin-bottom: 8px; padding: 8px"
            >
              <div
                class="white--text font-weight-light"
                style="font-size: 14px"
                :style="
                  mobileLang.code == lang.code
                    ? 'border-bottom: 1px solid white'
                    : ''
                "
              >
                {{ lang.name }}
              </div>
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Bottom -->
      <template v-slot:append>
        <!-- Disclaimer -->
        <div class="d-flex flex-column justify-center align-center pa-4 mb-5">
          <img
            v-if="mobileLang.code == 'el'"
            src="@/assets/images/logo-white.png"
            alt=""
            style="max-width: 200px"
          />
          <img
            v-else
            src="@/assets/images/logo-white-en.png"
            alt=""
            style="max-width: 200px"
          />
          <img
            src="@/assets/images/espa.png"
            class="mt-4"
            alt=""
            style="max-width: 200px"
          />
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      drawer: false,
    };
  },

  mounted() {},

  computed: {
    ...mapState({
      insets: (state) => state.base.insets,

      menuIconColor: (state) => state.base.menuIconColor,
      languages: (state) => state.base.languages,
      mobileLang: (state) => state.base.mobileLang,
    }),

    nav() {
      return `padding-top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      } + 16px)`;
    },

    main() {
      return `top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      } + 25px)`;
    },

    menu() {
      return [
        {
          label: this.$t("menu.home"),
          path: "/home",
        },

        {
          label: this.$t("menu.tours"),
          path: "/tour_list",
        },

        {
          label: this.$t("menu.colonies"),
          path: "/city_list",
        },

        // {
        //   label: this.$t("menu.search"),
        //   path: "",
        // },

        {
          label: this.$t("menu.info"),
          path: "/info",
        },
      ];
    },
  },

  methods: {
    ...mapMutations(["setMobileLang", "setToursFetched"]),
    ...mapActions(["getTours"]),

    async onLanguageSelect(lang) {
      this.$i18n.locale = lang.code;
      this.setMobileLang(lang);
      axios.defaults.headers.common["Accept-Language"] = `${lang.code}`;
      this.setToursFetched(false);
      await this.getTours();
      this.$router.go();
    },

    openDrawer() {
      this.drawer = true;
    },
    closeDrawer() {
      this.drawer = false;
    },
  },
};
</script>

<style scoped lang="scss">
.v-btn {
  text-transform: none !important;
}

.v-btn--active {
  width: fit-content;
}
</style>
